export default "__VITE_ASSET__BAG4iK1N__"